<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
        <div class="section-1400 pt-xl-4 padding-bottom-40 margin-auto">
            <div class="container-fluid padding-40 card">

                <!-- List View -->
                <div *ngIf="viewMode==='list'" class="row mt-3 ">

                    <!-- Title + Add Button -->
                    <div class="rana-page-header col-12">
                        <div>
                            <h1 class="rana-page-title">Business Directory</h1>
                            <p class="rana-page-subtitle mb-0">
                                {{ businesses.length }} business{{ businesses.length === 1 ? '' : 'es' }} listed by RANA members
                            </p>
                        </div>
                        <button class="btn btn-dark-primary" (click)="openCreateForm()" *ngIf="userId  && userRole?.BUSINESS?.includes('CREATE')">
                            <i class="uil uil-plus-circle mr-1"></i> Add Business
                        </button>
                    </div>


                    <!-- Loading -->
                    <div *ngIf="loading" class="col-12 d-flex justify-content-center align-items-center py-5">
                        <div class="text-muted">
                            <i class="uil uil-spinner-alt spin-animation mr-2"></i>Loading businesses...
                        </div>
                    </div>

                    <!-- No data -->
                    <div *ngIf="!loading && businesses.length === 0" class="col-12">
                        <div class="rana-panel text-center py-5">
                            <i class="uil uil-shop size-40 color-primary mb-2 d-block"></i>
                            <strong class="d-block mb-1">No businesses available yet.</strong>
                            <p class="mb-0 text-muted">Once businesses are added, they will appear here.</p>
                        </div>
                    </div>

                    <!-- DESKTOP TABLE VIEW -->
                    <div class="container-fluid px-2 rana-table-flat rana-div-grid" *ngIf="!loading && businesses.length > 0">

                        <!-- Header (hidden on mobile) -->
                        <div class="row d-none d-md-flex rana-div-table-header">
                            <div class="col-md-3">Business Name</div>
                            <div class="col-md-2">Industry</div>
                            <div class="col-md-2">Created By</div>
                            <div class="col-md-3">Website</div>
                            <div class="col-md-2 text-end">Actions</div>
                        </div>

                        <!-- Rows -->
                        <div class="row border-bottom align-items-center rana-div-table-row"
                             *ngFor="let biz of businesses | paginate: { itemsPerPage: 10, currentPage: page }; let i = index"
                             (click)="viewBusiness(biz)" style="cursor: pointer;">

                            <!-- Business Name -->
                            <div class="col-12 col-md-3 d-flex align-items-center" style="gap:10px;">
                                <div class="rana-avatar flex-shrink-0">{{ bizInitials(biz.businessName) }}</div>
                                <span class="fw-semibold">{{ biz.businessName }}</span>
                            </div>

                            <!-- Industry -->
                            <div class="col-12 col-md-2">
                                <span class="d-md-none fw-semibold">Industry: </span>
                                <span class="rana-badge rana-badge-accent" *ngIf="biz.industry">{{ getCategoryName(biz?.industry) }}</span>
                            </div>

                            <!-- Created By -->
                            <div class="col-12 col-md-2">
                                <span class="d-md-none fw-semibold">Created By: </span>
                                {{ biz.createdByName }}
                            </div>

                            <!-- Website -->
                            <div class="col-12 col-md-3">
                                <span class="d-md-none fw-semibold">Website: </span>
                                <a *ngIf="biz.website" [href]="biz.website" target="_blank"
                                   class="rana-biz-link"
                                   (click)="$event.stopPropagation()">
                                    <i class="uil uil-globe"></i> {{ biz.website }}
                                </a>
                            </div>

                            <!-- Actions -->
                            <div class="col-12 col-md-2 text-md-end mt-2 mt-md-0 d-flex justify-content-md-end" style="gap:8px;">
                                <button type="button"
                                        class="rana-action-btn"
                                        *ngIf="biz.createdBy === userId"
                                        (click)="editBusiness(biz); $event.stopPropagation()">
                                    <i class="uil uil-edit"></i> Edit
                                </button>

                                <button type="button"
                                        class="rana-action-btn rana-action-btn-danger"
                                        *ngIf="biz.createdBy === userId"
                                        (click)="deleteBusiness(biz.id); $event.stopPropagation()">
                                    <i class="uil uil-trash-alt"></i> Delete
                                </button>
                            </div>
                        </div>

                        <!-- Pagination -->
                        <div class="mt-3">
                            <pagination-controls (pageChange)="page = $event"></pagination-controls>
                        </div>

                    </div>


                </div>


                <!-- Form View -->
                <div *ngIf="viewMode==='form'" class="rana-detail-card">

                    <div class="rana-detail-header">
                        <div class="rana-avatar rana-detail-avatar">
                            <i class="uil uil-briefcase-alt"></i>
                        </div>
                        <div class="rana-detail-header-text">
                            <h1 class="rana-detail-title">{{ isEditing ? 'Edit Business' : 'Add Business' }}</h1>
                            <div class="rana-detail-meta">
                                {{ isEditing ? 'Update the details of your business listing.' : 'Share your business with the RANA community.' }}
                            </div>
                        </div>
                    </div>

                    <div class="rana-detail-divider"></div>

                    <!-- Form -->
                    <form class="nfr-form-standard" [formGroup]="bizForm" (ngSubmit)="onSubmit()">
                        <div class="rana-detail-content">
                            <div class="row">

                                <!-- Business Name -->
                                <div class="col-md-6 mb-3">
                                    <label>Business Name</label>
                                    <input type="text" formControlName="businessName"
                                           class="form-style big with-border form-style-with-icon">
                                </div>

                                <!-- Category -->
                                <div class="col-md-6 mb-3">
                                    <label>Category</label>
                                    <select formControlName="industry"
                                            class="form-style big with-border form-style-with-icon">
                                        <option value="" disabled>Select Category</option>
                                        <optgroup *ngFor="let group of businessCategories" [label]="group.group">
                                            <option *ngFor="let cat of group.categories" [value]="cat.code">
                                                {{ cat.name }}
                                            </option>
                                        </optgroup>
                                    </select>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="font-weight-600 size-14">Website</label>
                                    <input type="text"
                                           formControlName="website"
                                           placeholder="https://example.com"
                                           class="form-style big with-border"
                                           [class.is-invalid]="bizForm.get('website')?.invalid && bizForm.get('website')?.touched">

                                    <div *ngIf="bizForm.get('website')?.invalid && bizForm.get('website')?.touched" class="text-danger size-12 mt-1">
                                        <i class="uil uil-exclamation-circle"></i> Please enter a valid URL (e.g., www.example.com)
                                    </div>

                                </div>
                                <!-- Description (Ngx Editor) -->
                                <div class="col-md-12 mb-3">
                                    <label>Description</label>
                                    <app-rt-editor formControlName="description" name="description" placeholder="Description of the business"></app-rt-editor>

                                </div>

                            </div>
                        </div>

                        <div class="rana-detail-actions">
                            <button type="button" class="rana-action-btn" (click)="backToList()">
                                <i class="uil uil-arrow-left"></i> Back
                            </button>
                            <button type="submit" class="btn btn-dark-primary">
                                <i class="uil" [ngClass]="isEditing ? 'uil-check-circle' : 'uil-plus-circle'"></i>
                                {{ isEditing ? 'Update' : 'Create' }}
                            </button>
                        </div>
                    </form>
                </div>

                <!-- Detail View -->
                <div *ngIf="viewMode==='detail' && selectedBusiness" class="rana-detail-card">

                    <div class="rana-detail-header">
                        <div class="rana-avatar rana-detail-avatar">{{ bizInitials(selectedBusiness.businessName) }}</div>
                        <div class="rana-detail-header-text">
                            <h1 class="rana-detail-title">{{ selectedBusiness.businessName }}</h1>
                            <div class="rana-detail-meta">
                                <span>{{ selectedBusiness.createdByName }}</span>
                                <span class="rana-detail-meta-dot">&middot;</span>
                                <span class="rana-badge rana-badge-accent" *ngIf="selectedBusiness.industry">{{ getCategoryName(selectedBusiness.industry) }}</span>
                                <ng-container *ngIf="selectedBusiness.website">
                                    <span class="rana-detail-meta-dot">&middot;</span>
                                    <a [href]="selectedBusiness.website" target="_blank" class="rana-biz-link">
                                        <i class="uil uil-globe"></i> {{ selectedBusiness.website }}
                                    </a>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="rana-detail-divider"></div>

                    <div class="rana-detail-content">
                        <app-rt-editor *ngIf="selectedBusiness.description" [disabled]="true" [ngModel]="selectedBusiness.description"></app-rt-editor>
                        <p class="text-muted mb-0" *ngIf="!selectedBusiness.description">No description provided.</p>
                    </div>

                    <div class="rana-detail-actions">
                        <button type="button" class="rana-action-btn" (click)="backToList()">
                            <i class="uil uil-arrow-left"></i> Back
                        </button>
                        <div class="d-flex" style="gap:10px;" *ngIf="selectedBusiness.createdBy === userId">
                            <button type="button" class="rana-action-btn" (click)="editBusiness(selectedBusiness)">
                                <i class="uil uil-edit"></i> Edit
                            </button>
                            <button type="button" class="rana-action-btn rana-action-btn-danger" (click)="deleteBusiness(selectedBusiness.id)">
                                <i class="uil uil-trash-alt"></i> Delete
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
